module.exports = __webpack_public_path__ + "img/hr-level1_idle_shadow.03dad3aa.png";